function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluePaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.857,
    height: 10,
    viewBox: "0 0 7.857 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 144850",
    transform: "translate(1.786 5.714)",
    style: {
      fill: "#203662"
    },
    d: "M0 0h4.286v.714H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 144851",
    transform: "translate(1.786 3.929)",
    style: {
      fill: "#203662"
    },
    d: "M0 0h4.286v.714H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 144852",
    transform: "translate(1.786 7.5)",
    style: {
      fill: "#203662"
    },
    d: "M0 0h4.286v.714H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21258",
    d: "M12.143 3.071h-1.072v-.357A.714.714 0 0 0 10.357 2H7.5a.714.714 0 0 0-.714.714v.357H5.714A.714.714 0 0 0 5 3.786v7.5a.714.714 0 0 0 .714.714h6.429a.714.714 0 0 0 .714-.714v-7.5a.714.714 0 0 0-.714-.715zM7.5 2.714h2.857v1.429H7.5zm4.643 8.571H5.714v-7.5h1.072v1.072h4.286V3.786h1.071z",
    style: {
      fill: "#203662"
    },
    transform: "translate(-5 -2)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePaste);
export default __webpack_public_path__ + "static/media/BluePaste.c87bb95e53747f113a2f05c1ae54dd4a.svg";
export { ForwardRef as ReactComponent };